import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=4df24a3e&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=4df24a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df24a3e",
  null
  
)

export default component.exports